import { router } from '$lib/router/router.svelte';

export type ScopeFn = () => number;

export function resolveScope(scope: number | ScopeFn): number {
	return typeof scope === 'function' ? scope() : scope;
}

export function getUnitScope(): ScopeFn {
	return () => router.unitId ?? 0;
}

export function getProjectScope(): ScopeFn {
	return () => router.projectId ?? 0;
}
